import { uniq } from "lodash";

function renderFixed(value, params, configKey) {
  const { decimalPlaces = null } = params.column.colDef[configKey] || {};
  if (typeof value !== "number") {
    return null;
  }
  if (typeof decimalPlaces !== "number") {
    return value;
  }
  return value.toFixed(decimalPlaces);
}

export function avgAggFunction(params) {
  const { values } = params;
  // the average will be the sum / count
  let sum = 0;
  let count = 0;
  let avg = null;

  values.forEach(value => {
    const groupNode =
      value !== null && value !== undefined && typeof value === "object";
    if (groupNode) {
      // we are aggregating groups, so we take the
      // aggregated values to calculate a weighted average
      sum += value.avg * value.count;
      count += value.count;
    }
    // skip values that are not numbers (ie skip empty values)
    else if (typeof value === "number") {
      sum += value;
      count++;
    }
  });

  // avoid divide by zero error
  if (count !== 0) {
    avg = sum / count;
  }

  // the result will be an object. when this cell is rendered, only the avg is shown.
  // however when this cell is part of another aggregation, the count is also needed
  // to create a weighted average for the next level.
  return {
    count,
    avg,
    // the grid by default uses toString to render values for an object, so this
    // is a trick to get the default cellRenderer to display the avg value
    toString() {
      return renderFixed(this.avg, params, "aggFuncParams");
    },
  };
}

export const rollUp = params => {
  // List unique, non-empty values in the column like: 3, 4, 5.
  // If more than 3 values, show "+ X more" 3, 4, 5, +2 more
  const values = params.values || [];
  // When there are multiple grouped columns, it is possible that the values are stored in the array like this:
  // ["Crossbred, Dorper, Merino", "Crossbred"] we need to split these values before the uniq and filtering
  const splitValues = values.flatMap(value =>
    typeof value === "string" ? value.split(", ") : [value],
  );
  const filteredValues = uniq(splitValues.filter(Boolean));

  if (filteredValues.length === 0) {
    return "";
  }

  if (filteredValues.length <= 3) {
    return filteredValues.join(", ");
  }

  const visibleValues = filteredValues.slice(0, 3).join(", ");
  const moreCount = filteredValues.length - 3;

  return `${visibleValues}, +${moreCount} more`;
};
